/** CoStar.Api.SiteNavigation.ViewModels.ToggleState */
export var ToggleState;
(function (ToggleState) {
    ToggleState[ToggleState["None"] = 0] = "None";
    ToggleState[ToggleState["On"] = 10] = "On";
    ToggleState[ToggleState["Off"] = 20] = "Off";
})(ToggleState || (ToggleState = {}));
